import { LegacyParams, PublishersResponse } from '@/types/supports'

import { offerwallApi } from '../axiosInstance'

export const fetchPublishers = async (params: LegacyParams): Promise<PublishersResponse> => {
  const { data } = await offerwallApi.get<LegacyParams, PublishersResponse>('/publishers', {
    params: params,
    headers: {}
  })

  return data
}
